"use client";

import { selectableTrackOptions } from "@/lib/auth/cert-visibility";
import { professionForTrack } from "@/lib/onboarding/constants";
import { professionOf } from "@/lib/onboarding/flow";

import type { StepProps } from "../types";
import { SingleChoiceStep, useChooseAndAdvance } from "../ui";

export function TrackStep(props: StepProps) {
  const { state, env } = props;
  const choose = useChooseAndAdvance(props);
  const instructor = state.answers.audience === "instructor";
  const profession = professionOf(state);
  return (
    <SingleChoiceStep
      kicker="Your certification"
      title={instructor ? "Which certification do you teach?" : "Which certification?"}
      body={
        instructor
          ? "You can switch anytime in Settings."
          : "We'll only show you practice for your level."
      }
      // UX filter only: the submit action re-checks with trackIsSelectable.
      options={selectableTrackOptions(env.isInternal).filter(
        (t) => !profession || professionForTrack(t.value) === profession,
      )}
      selected={state.answers.track}
      onPick={(track) => choose({ track })}
    />
  );
}
